import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * PayLetter Return 페이지
 * 백엔드에서 PayLetter 결제 결과를 검증한 후 리다이렉트된 페이지
 * 백엔드에서 이미 payhash 검증을 완료하고 성공/실패 페이지로 리다이렉트함
 */
const PayLetterReturn: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
   

    // 백엔드에서 이미 검증을 완료했으므로 즉시 처리
    // 현재 이 페이지에 도달했다는 것은 백엔드에서 성공적으로 처리되었다는 의미
    
    // 잠시 로딩 화면을 보여준 후 성공 페이지로 이동
    // (백엔드에서 직접 성공/실패 페이지로 리다이렉트하도록 수정 권장)
    setTimeout(() => {
      navigate('/payment-success', { replace: true });
    }, 1500);

  }, [navigate]);

  return (
    <div style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh',
      flexDirection: 'column',
      backgroundColor: '#f8f9fa'
    }}>
      <div style={{ textAlign: 'center', padding: '40px' }}>
        <div style={{ 
          width: '60px', 
          height: '60px', 
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #28a745',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 20px auto'
        }}></div>
        <h2 style={{ marginBottom: '10px', color: '#333' }}>결제 처리 완료</h2>
        <p style={{ color: '#666', margin: 0 }}>
          PayLetter 결제가 성공적으로 처리되었습니다.<br/>
          결제 결과 페이지로 이동합니다...
        </p>
      </div>
      
      <style>{`
        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default PayLetterReturn; 